import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Table, Spinner, Button, Modal, Form, Pagination, Badge } from 'react-bootstrap';
import { QRCodeCanvas } from 'qrcode.react';
import { jsPDF } from "jspdf";

import NavbarComponent from '../layout/NavbarComponent';
import Footer from '../layout/Footer';
import { Layout } from '../layout/Layout';
import PaginationComponent from './PaginationComponent';
const API_URL = process.env.REACT_APP_API_URL;

const PetsDetails = () => {
    const [pets, setPets] = useState([]);
    const [loading, setLoading] = useState(true);

    const [page, setPage] = useState(0);
    const [size, setSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);

    const [qrUrls, setQrUrls] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [currentPetId, setCurrentPetId] = useState(null);
    const [qrInput, setQrInput] = useState('');

    const [showTagModal, setShowTagModal] = useState(false);
    const [selectedPet, setSelectedPet] = useState(null);
    const [oldCode, setOldCode] = useState("");
    const [savingTag, setSavingTag] = useState(false);
    const [isEditingOldCode, setIsEditingOldCode] = useState(false);



    const fetchPets = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${API_URL}/getallpets?page=${page}&size=${size}`
            );

            setPets(response.data.content);
            setTotalPages(response.data.totalPages);
        } catch (error) {
            console.error("Error fetching pets:", error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchPets();
    }, [page, size]);

    const handleOpenModal = (pet) => {
        const defaultUrl = `https://petroll.co/pet/view?token=${pet.secureToken}`;
        setCurrentPetId(pet.petId);
        setQrInput(defaultUrl);
        setShowModal(true);
    };

    const handleSaveQR = () => {
        if (currentPetId && qrInput) {
            setQrUrls(prev => ({ ...prev, [currentPetId]: qrInput }));
        }
        setShowModal(false);
    };

    const handleDownloadQRPDF = (petId, petName) => {
        const canvas = document.getElementById(`qr-${petId}`);
        if (canvas) {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF({ orientation: "portrait", unit: "px", format: [200, 250] });

            pdf.addImage(imgData, "PNG", 20, 20, 160, 160);
            pdf.setFontSize(12);
            pdf.text(`This QR is for pet: ${petName}`, 20, 200);

            pdf.save(`QR-Pet-${petName}.pdf`);
        }
    };
    const getDaysLeft = (expiryDate) => {
        if (!expiryDate) return 0;

        const today = new Date();
        const expiry = new Date(expiryDate);

        const diffTime = expiry.getTime() - today.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        return diffDays > 0 ? diffDays : 0;
    };

    const handleOpenTagModal = (pet) => {
        setSelectedPet(pet);

        if (pet.oldQrCode) {
            setOldCode(pet.oldQrCode);
            setIsEditingOldCode(false); // initially locked
        } else {
            setOldCode("");
            setIsEditingOldCode(true); // allow typing if no code exists
        }

        setShowTagModal(true);
    };


    const handleSaveOldCode = async () => {
        if (!oldCode || !selectedPet) return;

        try {
            setSavingTag(true);

            const res = await axios.post(
                `${API_URL}/addOldQrCode`,
                null,
                {
                    params: {
                        petId: selectedPet.petId,
                        oldCode: oldCode
                    }
                }
            );

            // ✅ SUCCESS (status 200–299)
            if (res.status === 200) {
                alert("QR tag linked successfully");
                setShowTagModal(false);
                setOldCode("");
            }

        } catch (error) {
            // console.error("Error saving old QR code:", error);

            // ❌ BACKEND ERROR MESSAGE (if sent)
            const message = error.response?.data || "Failed to link QR tag";
            alert(message); // ✅ shows the message

        } finally {
            setSavingTag(false);
        }

    };

    return (
      <Layout>
    <div className="pets-page">

        {loading ? (
            <div className="pets-loading">
                <Spinner animation="border" style={{ color: "#e07b39" }} />
            </div>
        ) : (
            <div className="pets-container">

                {/* Heading */}
                <div className="pets-heading-row">
                    <div>
                        <h2 className="pets-title">Pets Details</h2>
                        <p className="pets-subtitle">
                            {pets.length} {pets.length === 1 ? "pet" : "pets"} registered
                        </p>
                    </div>
                </div>

                {pets.length === 0 ? (
                    <div className="pets-empty">
                        <div className="pets-empty-badge">0</div>
                        <p className="pets-empty-text">No pets to display</p>
                        <p className="pets-empty-sub">New registrations will show up here.</p>
                    </div>
                ) : (
                    <>
                        {/* Table Card */}
                        <div className="pets-card">
                            <div className="table-responsive">
                                <Table className="pets-table mb-0 align-middle">
                                    <thead>
                                        <tr>
                                            <th>Pet ID</th>
                                            <th>Pet Name</th>
                                            <th className="d-none d-md-table-cell">Owner</th>
                                            <th>Lost</th>
                                            <th>Premium</th>
                                            <th className="d-none d-lg-table-cell">Days Left</th>
                                            <th>QR Code</th>
                                            <th>Tags</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {pets.map((pet) => (
                                            <tr key={pet.petId}>
                                                <td className="pets-id">{pet.petId}</td>
                                                <td className="fw-semibold">{pet.petName}</td>
                                                <td className="d-none d-md-table-cell text-muted">
                                                    {pet.owner?.userName || "N/A"}
                                                </td>

                                                {/* Lost Badge */}
                                                <td>
                                                    <span className={`pets-pill ${pet.lost ? "pets-pill--danger" : "pets-pill--success"}`}>
                                                        {pet.lost ? "Yes" : "No"}
                                                    </span>
                                                </td>

                                                {/* Premium Badge */}
                                                <td>
                                                    <span className={`pets-pill ${pet.premium ? "pets-pill--premium" : "pets-pill--muted"}`}>
                                                        {pet.premium ? "Yes" : "No"}
                                                    </span>
                                                </td>

                                                {/* Days Left */}
                                                <td className="d-none d-lg-table-cell">
                                                    {pet.premium ? (
                                                        <span className={`pets-pill ${getDaysLeft(pet.premiumExpiryDate) > 0 ? "pets-pill--success" : "pets-pill--danger"}`}>
                                                            {getDaysLeft(pet.premiumExpiryDate)} days
                                                        </span>
                                                    ) : (
                                                        <span className="text-muted">—</span>
                                                    )}
                                                </td>

                                                {/* QR Section */}
                                                <td>
                                                    <div className="d-flex flex-column align-items-start gap-2">

                                                        <button
                                                            className="pets-btn pets-btn--outline"
                                                            onClick={() => handleOpenModal(pet)}
                                                        >
                                                            Generate QR
                                                        </button>

                                                        {qrUrls[pet.petId] && (
                                                            <>
                                                                <div className="pets-qr-box">
                                                                    <button
                                                                        onClick={() =>
                                                                            setQrUrls(prev => ({
                                                                                ...prev,
                                                                                [pet.petId]: null,
                                                                            }))
                                                                        }
                                                                        className="pets-qr-close"
                                                                        aria-label="Remove QR code"
                                                                    >
                                                                        ✕
                                                                    </button>

                                                                    <QRCodeCanvas
                                                                        id={`qr-${pet.petId}`}
                                                                        value={qrUrls[pet.petId]}
                                                                        size={110}
                                                                        level="H"
                                                                    />
                                                                </div>

                                                                <button
                                                                    className="pets-btn pets-btn--success"
                                                                    onClick={() =>
                                                                        handleDownloadQRPDF(
                                                                            pet.petId,
                                                                            pet.petName
                                                                        )
                                                                    }
                                                                >
                                                                    Download
                                                                </button>
                                                            </>
                                                        )}
                                                    </div>
                                                </td>

                                                {/* Tags Button */}
                                                <td>
                                                    <button
                                                        className="pets-btn pets-btn--dark"
                                                        onClick={() => handleOpenTagModal(pet)}
                                                    >
                                                        Add Tags
                                                    </button>
                                                </td>

                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </div>

                        {/* Pagination */}
                        <div className="pets-pagination">
                            <PaginationComponent
                                page={page}
                                setPage={setPage}
                                size={size}
                                setSize={setSize}
                                totalPages={totalPages}
                            />
                        </div>
                    </>
                )}
            </div>
        )}

        {/* QR Modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)} centered className="pets-modal">
            <Modal.Header closeButton>
                <Modal.Title>Generate QR Code URL</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group>
                    <Form.Label>QR Code URL</Form.Label>
                    <Form.Control
                        type="text"
                        value={qrInput}
                        onChange={(e) => setQrInput(e.target.value)}
                        className="pets-input"
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <button className="pets-btn pets-btn--ghost" onClick={() => setShowModal(false)}>
                    Cancel
                </button>
                <button className="pets-btn pets-btn--solid" onClick={handleSaveQR}>
                    Save & Generate QR
                </button>
            </Modal.Footer>
        </Modal>

        {/* TAG MODAL */}
        <Modal show={showTagModal} onHide={() => setShowTagModal(false)} centered className="pets-modal">
            <Modal.Header closeButton>
                <Modal.Title>Add QR Tag</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {/* Pet Name */}
                <Form.Group className="mb-3">
                    <Form.Label>Pet Name</Form.Label>
                    <Form.Control
                        type="text"
                        value={selectedPet?.petName || ""}
                        readOnly
                        className="pets-input"
                    />
                </Form.Group>

                {/* Old QR Code */}
                <Form.Group>
                    <Form.Label>QR Code Link</Form.Label>

                    <div className="d-flex gap-2">
                        <Form.Control
                            type="text"
                            value="https://app.petroll.co/pet/"
                            readOnly
                            className="pets-input"
                            style={{ maxWidth: "260px" }}
                        />

                        <Form.Control
                            type="text"
                            placeholder="0123A456B789"
                            value={oldCode}
                            disabled={!isEditingOldCode}
                            onChange={(e) => setOldCode(e.target.value)}
                            className="pets-input"
                        />
                    </div>

                    <small className="text-muted">
                        Enter only the code printed on the QR tag
                    </small>

                    {/* UPDATE BUTTON */}
                    {selectedPet?.oldQrCode && !isEditingOldCode && (
                        <div className="mt-2">
                            <button
                                className="pets-btn pets-btn--outline pets-btn--sm"
                                onClick={() => setIsEditingOldCode(true)}
                            >
                                Update QR Code
                            </button>
                        </div>
                    )}
                </Form.Group>
            </Modal.Body>

            <Modal.Footer>
                <button className="pets-btn pets-btn--ghost" onClick={() => setShowTagModal(false)}>
                    Cancel
                </button>

                <button
                    className="pets-btn pets-btn--solid"
                    onClick={handleSaveOldCode}
                    disabled={!oldCode || savingTag}
                >
                    {savingTag ? "Saving..." : "Save"}
                </button>
            </Modal.Footer>
        </Modal>

    </div>

    <style>{`
        .pets-page {
            min-height: 100vh;
            background: #F7F8F6;
            display: flex;
            flex-direction: column;
            font-family: 'Inter', sans-serif;
        }

        .pets-loading {
            display: flex;
            justify-content: center;
            align-items: center;
            flex: 1;
        }

        .pets-container {
            max-width: 1180px;
            width: 100%;
            margin: 0 auto;
            padding: 32px 24px;
            flex: 1;
        }

        .pets-heading-row {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            margin-bottom: 22px;
        }

        .pets-title {
            font-weight: 700;
            font-size: 24px;
            color: #1C2420;
            margin: 0;
        }

        .pets-subtitle {
            font-size: 13.5px;
            color: #8B978F;
            margin: 4px 0 0;
        }

        .pets-empty {
            text-align: center;
            padding: 72px 20px;
            background: #fff;
            border-radius: 16px;
            border: 1px solid #EDEFEA;
        }

        .pets-empty-badge {
            width: 44px;
            height: 44px;
            border-radius: 50%;
            background: rgba(224, 123, 57, 0.1);
            color: #e07b39;
            font-weight: 700;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 16px;
        }

        .pets-empty-text {
            font-weight: 600;
            font-size: 17px;
            color: #1C2420;
            margin: 0 0 4px;
        }

        .pets-empty-sub {
            font-size: 13.5px;
            color: #8B978F;
            margin: 0;
        }

        .pets-card {
            background: #fff;
            border-radius: 16px;
            border: 1px solid #EDEFEA;
            box-shadow: 0 1px 2px rgba(16, 24, 20, 0.03);
            overflow: hidden;
        }

        .pets-table thead {
            background: rgba(224, 123, 57, 0.06);
        }

        .pets-table thead th {
            font-size: 11.5px;
            text-transform: uppercase;
            letter-spacing: 0.06em;
            font-weight: 700;
            color: #B8632C;
            padding: 14px 16px;
            border-bottom: 1px solid #F0E4D8;
            white-space: nowrap;
        }

        .pets-table tbody td {
            padding: 14px 16px;
            font-size: 14px;
            color: #333B36;
            border-bottom: 1px solid #F2F3F0;
            vertical-align: middle;
        }

        .pets-table tbody tr:last-child td {
            border-bottom: none;
        }

        .pets-table tbody tr:hover {
            background: #FBFAF8;
        }

        .pets-id {
            font-weight: 600;
            color: #5C6862;
        }

        .pets-pill {
            display: inline-block;
            padding: 4px 11px;
            border-radius: 999px;
            font-size: 12px;
            font-weight: 600;
        }

        .pets-pill--success { background: rgba(47, 158, 106, 0.12); color: #21875A; }
        .pets-pill--danger  { background: rgba(214, 68, 55, 0.1); color: #C13B2D; }
        .pets-pill--premium { background: rgba(224, 123, 57, 0.14); color: #B8632C; }
        .pets-pill--muted   { background: #F0F1EE; color: #8B978F; }

        .pets-btn {
            font-size: 13px;
            font-weight: 600;
            padding: 7px 14px;
            border-radius: 8px;
            border: 1.5px solid transparent;
            cursor: pointer;
            transition: all 0.15s ease;
            white-space: nowrap;
        }

        .pets-btn--sm { padding: 5px 11px; font-size: 12px; }

        .pets-btn--outline {
            background: #fff;
            border-color: #e07b39;
            color: #e07b39;
        }
        .pets-btn--outline:hover { background: rgba(224, 123, 57, 0.08); }

        .pets-btn--solid {
            background: #e07b39;
            color: #fff;
        }
        .pets-btn--solid:hover { background: #c96a2d; }
        .pets-btn--solid:disabled { opacity: 0.55; cursor: not-allowed; }

        .pets-btn--success {
            background: rgba(47, 158, 106, 0.12);
            color: #21875A;
        }
        .pets-btn--success:hover { background: rgba(47, 158, 106, 0.2); }

        .pets-btn--dark {
            background: #1C2420;
            color: #fff;
        }
        .pets-btn--dark:hover { background: #313b35; }

        .pets-btn--ghost {
            background: transparent;
            color: #5C6862;
            border-color: #E2E5E0;
        }
        .pets-btn--ghost:hover { background: #F5F6F4; }

        .pets-qr-box {
            position: relative;
            background: #fff;
            border: 1px solid #EDEFEA;
            border-radius: 12px;
            padding: 10px;
            text-align: center;
        }

        .pets-qr-close {
            position: absolute;
            top: 6px;
            right: 6px;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            border: none;
            background: #F0F1EE;
            color: #5C6862;
            font-size: 10px;
            line-height: 1;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .pets-qr-close:hover { background: #e6e8e3; }

        .pets-pagination {
            margin-top: 20px;
            display: flex;
            justify-content: flex-end;
        }

        .pets-modal .modal-content {
            border-radius: 16px;
            border: none;
        }

        .pets-modal .modal-header {
            background: rgba(224, 123, 57, 0.06);
            border-bottom: 1px solid #F0E4D8;
        }

        .pets-modal .modal-title {
            color: #B8632C;
            font-weight: 700;
            font-size: 18px;
        }

        .pets-modal .modal-footer {
            border-top: 1px solid #F0F1EE;
        }

        .pets-input {
            border-radius: 8px !important;
            border: 1.5px solid #E2E5E0 !important;
        }
        .pets-input:focus {
            border-color: #e07b39 !important;
            box-shadow: 0 0 0 3px rgba(224, 123, 57, 0.12) !important;
        }
    `}</style>
</Layout>
    );
};

export default PetsDetails;
